import { ZmanimData } from '../types';
import {
  CANDLE_LIGHTING_MINUTES_BEFORE_SUNSET,
  RABBEINU_TAM_MINUTES_AFTER_SUNSET,
  TZEIT_MINUTES_AFTER_SUNSET,
} from '../config/constants';
import { applyOffset } from './timeUtils';

/**
 * The app's own definitions, applied to every day's zmanim whatever their source
 * (MyZmanim cache or Hebcal), so both always agree (Yoel, October 4, 2026):
 * - Tzeit HaKochavim = sunset + 33 minutes (MyZmanim's "Night72fix" is 72).
 * - Tzeit Rabbeinu Tam = sunset + 72 minutes.
 * - Candle lighting = sunset - 20 minutes, on days that have candle lighting
 *   before sunset. Lighting after dark (the second night of Yom Tov, Yom Tov
 *   after Shabbos) is kept as the source gives it.
 */
export function normalizeZmanim(z: ZmanimData): ZmanimData {
  if (!z.SunsetDefault || z.SunsetDefault === '00:00') return z;
  const candle =
    z.candleLighting && z.candleLighting <= z.SunsetDefault
      ? applyOffset(z.SunsetDefault, -CANDLE_LIGHTING_MINUTES_BEFORE_SUNSET)
      : z.candleLighting;
  return {
    ...z,
    Tzet: applyOffset(z.SunsetDefault, TZEIT_MINUTES_AFTER_SUNSET),
    TzetRabbeinuTam: applyOffset(z.SunsetDefault, RABBEINU_TAM_MINUTES_AFTER_SUNSET),
    ...(candle ? { candleLighting: candle } : {}),
  };
}
